import React from "react";
import InitialReminders from "./InitialReminders";

interface LogTrendsProps {
  logDetailsScreenKey?: any;
  chartTitle?: string;
  chartSection?: React.ReactNode;
  isFilters?: boolean;
  filterSection?: React.ReactNode;
  className?: any;
  selectionSection?: React.ReactNode;
}

const LogTrends: React.FC<LogTrendsProps> = ({
  logDetailsScreenKey,
  chartTitle,
  chartSection,
  isFilters,
  filterSection,
  className,
  selectionSection,
}) => {
  return (
    <div className="p-4 pt-6 relative bg-white">
      <div className="relative w-full space-y-4">
        <div className="flex items-center justify-between gap-4">
          {chartTitle && (
            <div className="relative">
              <h3>{chartTitle}</h3>
            </div>
          )}
          {isFilters && (
            <div className="flex bg-gray-100 rounded-lg p-1">
              {filterSection}
            </div>
          )}
        </div>
        {selectionSection && (
          <div className="w-full flex-1">{selectionSection}</div>
        )}
        <div className={`w-full bg-gray-50 p-2 rounded-lg ${className}`}>
          {chartSection}
        </div>

        <InitialReminders type={logDetailsScreenKey} isSetGoals={false} />
      </div>
    </div>
  );
};

export default LogTrends;
